import { useLayoutEffect } from 'react';
import { useAtomValue } from 'jotai';
import { accessibleViewAtom } from 'signer-app/signer-signature-document/accessible-document-toggle';

const isIOS = () => {
  const isIphone = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isIOSDesktopMode =
    navigator.userAgent.includes('Mac') && navigator.maxTouchPoints > 1;

  return isIphone || isIOSDesktopMode;
};

const setContainerHeight = (elementId: string, height: string) => {
  const container = document.getElementById(elementId);
  if (!container) return;

  container.style.height = height;

  return container;
};

const updateContainerHeight = (elementId: string) => {
  const vv = window.visualViewport;
  const height = vv ? vv.height : window.innerHeight;

  const container = setContainerHeight(elementId, `${height}px`);

  if (container) {
    window.scroll(0, 0);
  }
};

const useIOSViewportFix = (elementId: string) => {
  const isFormViewEnabled = useAtomValue(accessibleViewAtom);

  useLayoutEffect(() => {
    if (!isIOS() || !elementId) {
      return;
    }
    if (!isFormViewEnabled) {
      updateContainerHeight(elementId);
    }

    // Use visualViewport events on iOS
    if (window.visualViewport) {
      if (isFormViewEnabled) {
        setContainerHeight(elementId, '100%');
      } else {
        const visualViewport = window.visualViewport;

        let timeout: string | number | NodeJS.Timeout;
        const onChange = () => {
          clearTimeout(timeout);
          timeout = setTimeout(() => updateContainerHeight(elementId), 50); // avoid jitter
        };

        visualViewport.addEventListener('resize', onChange);
        visualViewport.addEventListener('scroll', onChange);

        return () => {
          visualViewport.removeEventListener('resize', onChange);
          visualViewport.removeEventListener('scroll', onChange);
          clearTimeout(timeout);
        };
      }
    }

    return () => {};
  }, [isFormViewEnabled, elementId]);
};

export default useIOSViewportFix;
